export const REFRESH_INTERVAL = 5000;
export const AVATAR_SIZE = 35;
export const CSS_SIZE_SM = 576;
